import BaseComponent from './BaseComponent';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let components = [];

export default class BackgroundAnimation extends BaseComponent {
	constructor(element) {
		super();

		this.element = element;
		this.bg = this.element.querySelector('[data-bg]');

		const mm = gsap.matchMedia();

		mm.add('(prefers-reduced-motion: no-preference)', () => {
			this.tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.element,
					start: 'top 80%',
					once: true,
				},
			});

			gsap.set(this.bg, {
				scale: 0.5,
				opacity: 0.5,
			});

			this.tl.to(this.bg, {
				scale: 1,
				duration: 0.8,
				ease: 'power2.out',
			});

			this.tl.to(
				this.bg,
				{
					opacity: 1,
					duration: 0.6,
					ease: 'power2.out',
				},
				'<0.2'
			);

			return () => {
				if (this.tl) {
					this.tl.kill();
					this.tl = null;
				}
			};
		});
	}

	destroy() {
		super.destroy();

		if (this.tl) {
			this.tl.kill();
			this.tl = null;
		}
	}
}

document.addEventListener('bless', (e) => {
	components.forEach((component) => component.destroy());
	components = [];

	const container = e.detail?.next?.container;

	if (!container) {
		return;
	}

	[...container.querySelectorAll('[data-animate-bg]')].forEach((element) => {
		components.push(new BackgroundAnimation(element));
	});
});
